/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UserProfilebyWorkTypeViewModel { 
    userNo?: string;
    userName?: string;
    telephone?: string;
    telephoneExtension?: string;
    cellPhone?: string;
    email?: string;
    gender?: boolean;
    enable?: boolean;
    hireDate?: Date;
    quitDate?: Date;
    trialDate?: Date;
    departmentId?: number;
    jobTitleId?: number;
    mainDuty?: boolean;
    priority?: number;
    firstPriority?: boolean;
    departmentCode?: string;
    departmentName?: string;
    departmentLevel?: number;
    parentDepartmentId?: number;
    workType?: number;
}